import scssVariables from '@styles/base/variable-export.scss'
const DEFAULT_ZINDEX = scssVariables.MASK_Z_INDEX
let nextZIndex = DEFAULT_ZINDEX

function getZIndex() {
  return nextZIndex++
}

export default {
  getZIndex
}

export {
  getZIndex
}
